module.exports = __webpack_public_path__ + "static/banner-update-data-ec-7bc2ac400ba6c0c05318d8ea46e7199b.png";